export default {
	data() {
		return {
			//用户头像
			headImg: require('../../assets/images/avatar.jpg'),
			//用户信息
			users: [],
			// 每页显示条数
			pageSize: 20,
			// 当前页
			currentPage: 1,
			// 总页数
			total: 0,
			// 起始位置
			offset: 0,
			// 课程
			classList: [],
			// 列表类型 0全部课程 1在读课程 2已完成课程 4个人信息
			listType: 0,
			//课程列表
			classList: [],
			loading: false,
			// 个人信息需要用到的参数--------
			index: 0,
			message: '',
			oldPassword: '',
			newPassword: '',
			confirmPassword: '',
			personageMessage: '',
			isPersonageMessage: false,
			users: {
				name: '',
				company: '',
				email: '',
				idcard: '',
			},
			// 我的风格列表
			styleList:[
				require('@/assets/images/personalcenter.png'),
				require('@/assets/images/personalcenter1.png'),
				require('@/assets/images/personalcenter2.png'),
			],
			// 控制我的风格线边框高度
			styleBorderTop:470,
			// 当前选择的风格
			radio:1
		}
	},
	methods: {
		//更换风格
		currentStyleButton(){
			this.$post('users/style_current',{
				my_style:this.radio,
				token:this.$store.state.id
			}).then(res=>{
				this.$store.state.my_style = this.radio
				if(this.radio == 0 ){
					this.$router.push('/personalcenter')
				}
				if(this.radio == 2 ){
					this.$router.push('/personalcenter2')
				}
			})
			
		},
		//点击更换风格
		currentstyle(index){
			this.styleBorderTop = index * 470
			this.radio = index
		},
		//旧密码框获取焦点
		OldPasswordFocus: function() {
			if (this.personageMessage === '旧密码不能为空' || this.personageMessage === '旧密码不正确') {
				this.isPersonageMessage = false;
			}
		},
		//密码框获取焦点
		PasswordFocus: function() {
			if (this.personageMessage === '密码不能为空' || this.personageMessage === '两次密码不匹配') {
				this.isPersonageMessage = false;
			}
		},
		//确认密码框获取焦点
		AffirmPasswordFocus: function() {
			if (this.personageMessage === '确认密码不能为空' || this.personageMessage === '两次密码不匹配') {
				this.isPersonageMessage = false;
			}
		},

		getusers: function() {
			this.$post('users/profile', {
				token: this.$store.state.id
			}).then(res => {
				this.users.name = res.data.result.name;
				this.users.company = res.data.result.company;
				this.users.email = res.data.result.email;
				this.users.idcard = res.data.result.idcard;
				this.users.name ? document.querySelector('#name').setAttribute("disabled", "disabled") : this.users.name;
			})
		},
		//邮箱校验
		checkEmail() {
			if (this.users.email != '') {
				let emsreg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
				if (!emsreg.test(this.users.email)) {
					// // console.log('邮箱格式错误')
				} else {
					// savePersonal()
				}
			} else {
				// savePersonal()
			}
		},
		savePersonal() {
			// // console.log(this.checkEmail());
			this.$post('users/edit', {
				token: this.$store.state.id,
				name: this.users.name,
				email: this.users.email,
				company: this.users.company,
				idcard: this.users.idcard
			}).then(res => {
				if (res.data.status === 'fail') {
					this.message = '修改失败';
					let model = document.querySelector('#modal-close-default-two');
					UIkit.modal(model).show();
					// this.$message.error('修改失败');
				} else {
					// this.$message.success('修改成功');
					this.message = '修改成功';
					this.$store.state.name = this.users.name;
					let model = document.querySelector('#modal-close-default-two');
					UIkit.modal(model).show();
					this.getusers();
				}
			})
			// }


		},
		//获取个人信息
		getUsers: function() {
			this.$post('users/profile', {
				token: this.$store.state.id
			}).then(res => {
				this.users = res.data.result;
				// this.users.name ? document.querySelector('#name').setAttribute('disabled', 'disabled') : this.users.name;
				// this.users.company ? document.querySelector('#company').setAttribute('disabled', 'disabled') : this.users.company;
				//判断信息是否完成，如若一项不完成都弹出下面的提示
				if (this.users.name == null || this.users.company == null || this.users.name == '' || this.users.company == '') {
					// this.message = '请完善个人信息，如不需要开具学时证明，则可以不填写。';
					// let model = document.querySelector('#modal-tip-addname');
					// UIkit.modal(model).show();
				} else {
					// let model = document.querySelector('#modal-tip-addname');
					// UIkit.modal(model).show();
				}
			})
		},

		// 每页的显示条数改变时调用
		handleSizeChange(pageSize) {
			this.pageSize = pageSize

		},

		// 当前页改变时调用
		handleCurrentChange(currentPage) {
			this.currentPage = currentPage
			this.offset = (currentPage - 1) * this.pageSize
		},

		//获取课程信息
		getProduct(type = 0) {
			this.listType = type
			let url = 'purchased/search_pay_all';
			let data = {
				token: this.$store.state.id,
				offset: this.offset,
				length: this.pageSize,
			}
			if (this.listType == 0) {
				this.getData(url, data);
			} else if (this.listType == 1) {
				url = 'purchased/search_pay_all_type_two'
				data.progress_lt = 1
				this.getData(url, data);
			} else if (this.listType == 2) {
				data.progress = 1
				this.getData(url, data);
			} else if (this.listType == 3 || this.listType == 4) {
				this.getusers()

			}

		},

		//获取课程请求
		getData(url, data) {
			this.loading = true
			this.$post(url, data).then(res => {
				this.total = res.data.result.total
				this.classList = res.data.result.data;
				this.loading = false;
			})
		},

		//跳转课程详情
		classDetails: function(id, is_project) {
			// // console.log(id,is_project);
			this.$toClass(id, is_project);
			// let address = this.$router.resolve({
			//     path: '/classstudy',
			//     query: {
			//         id: id
			//     }
			// })
			// window.open(address.href, '_blank');
		},

		//修改密码
		changePassword: function() {
			if (!this.oldPassword.trim()) {

				this.personageMessage = '旧密码不能为空';
				this.isPersonageMessage = true;
			} else if (!this.newPassword.trim()) {
				this.personageMessage = '密码不能为空';
				this.isPersonageMessage = true;
			} else if (!this.confirmPassword.trim()) {
				this.personageMessage = '确认密码不能为空';
				this.isPersonageMessage = true;
			} else if (this.newPassword.trim() !== this.confirmPassword.trim()) {
				this.personageMessage = '两次密码不匹配';
				this.isPersonageMessage = true;
			} else {
				this.$post('users/setpswd', {
					token: this.$store.state.id,
					opassword: this.oldPassword,
					password: this.newPassword
				}).then(res => {
					if (res.data.status === 'fail') {
						this.personageMessage = '旧密码不正确';
						this.isPersonageMessage = true;
					} else {
						this.message = '修改成功';
						let model = document.querySelector('#modal-close-default-two');
						UIkit.modal(model).show();
					}
				})
			}
		},
		//旧密码框获取焦点
		OldPasswordFocus: function() {
			if (this.personageMessage === '旧密码不能为空' || this.personageMessage === '旧密码不正确') {
				this.isPersonageMessage = false;
			}
		},
		//密码框获取焦点
		PasswordFocus: function() {
			if (this.personageMessage === '密码不能为空' || this.personageMessage === '两次密码不匹配') {
				this.isPersonageMessage = false;
			}
		},
		//确认密码框获取焦点
		AffirmPasswordFocus: function() {
			if (this.personageMessage === '确认密码不能为空' || this.personageMessage === '两次密码不匹配') {
				this.isPersonageMessage = false;
			}
		},

	},
	components: {},
	created() {
		this.getusers()
		this.getProduct()
		this.getUsers();
	},
	mounted() {}
}
